import { t } from '../i18n';

export const validateIntentName = (value: string): string => {
    if (!/^[a-zA-Z_][0-9a-zA-Z_.]*$/.test(value)) {
        return t('intent-name');
    }
    return '';
};
